import { Text } from '@thanx/uikit/text'
import { ColorPicker } from 'components/Form/ColorPicker'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyleSection } from './hooks'

const t = buildTranslate('cms.content.app_navigation.style')

const StyleSection: React.FC = () => {
  const { state, actions } = useStyleSection()

  return (
    <div>
      <Text.Header4 className="mb-m">{t('style_section.title')}</Text.Header4>

      <ColorPicker
        className="mb-m"
        label={t('style_section.background_color')}
        value={state.backgroundColor}
        setValue={actions.updateBackgroundColor}
        errorMessage=""
        isPristine={!state.hasChanges}
        startEnhancer
      />

      <ColorPicker
        className="mb-m"
        label={t('style_section.label_default_color')}
        value={state.defaultLabelColor}
        setValue={actions.updateDefaultLabelColor}
        errorMessage=""
        isPristine={!state.hasChanges}
        startEnhancer
      />

      <ColorPicker
        label={t('style_section.label_selected_color')}
        value={state.selectedLabelColor}
        setValue={actions.updateSelectedLabelColor}
        errorMessage=""
        isPristine={!state.hasChanges}
        startEnhancer
      />
    </div>
  )
}

export default StyleSection
